import { anchantoRouting, jubelioRouting } from '@anyx/integrations-inventory';

export const inventoryIntegrationRoutes = {
  path: 'ddi-inventory',
  children: [jubelioRouting, anchantoRouting],
};
